export default __webpack_public_path__ + "static/media/1991.152c9e4a.png";